import React from "react";
const CrestDowntimeNotication=
{
    title: "We're updating your bank details",
    body:"Unfortunately, you can’t update your bank details at the moment. Please try again in a few hours.",
    subBody:
    "This is for the account we pay money into. Do you also need to update the account we collect payments from?",
contactText:"Please contact us to do that.",
mail:"Send a message",
International: (
    <React.Fragment>
<p style={{fontSize:"16px"}} >
Unfortunately, you can’t update your bank details at the moment. Please try again in a few hours.<br>
      </br>
     
      </p>
    </React.Fragment>
  )
};
export default CrestDowntimeNotication;